import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DiscussionComment, Pagination } from '../types';

@Injectable({
  providedIn: 'root',
})
export class DiscussionsService {
  private httpClient = inject(HttpClient);
  readonly apiHost = `${environment.apiBaseUrl}/discussions`;

  //[HttpGet("{type}/{referenceId}/comments")]
  getComments(type: string, referenceId: string, limit: number, page: number): Observable<Pagination<DiscussionComment>> {
    const requestUrl = `${this.apiHost}/${type}/${referenceId}/comments`;
    const params = new HttpParams().set('items_per_page', limit.toString()).set('page', page.toString());
    return this.httpClient.get<Pagination<DiscussionComment>>(requestUrl, { params });
  }

  //[HttpGet("{type}/{referenceId}/comments/{commentId:guid}")]
  getComment(type: string, referenceId: string, commentId: string): Observable<DiscussionComment> {
    const requestUrl = `${this.apiHost}/${type}/${referenceId}/comments/${commentId}`;
    return this.httpClient.get<DiscussionComment>(requestUrl);
  }

  //[HttpPost("{type}/{referenceId}/comments")]
  createComment(type: string, referenceId: string, comment: string): Observable<DiscussionComment> {
    const requestUrl = `${this.apiHost}/${type}/${referenceId}/comments`;
    return this.httpClient.post<DiscussionComment>(requestUrl, { comment });
  }

  //[HttpPatch("{type}/{referenceId}/comments/{commentId:guid}")]
  updateComment(type: string, referenceId: string, commentId: string, comment: string): Observable<unknown> {
    const requestUrl = `${this.apiHost}/${type}/${referenceId}/comments/${commentId}`;
    return this.httpClient.patch<unknown>(requestUrl, { comment });
  }

  //[HttpDelete("{type}/{referenceId}/comments/{commentId:guid}")]
  deleteComment(type: string, referenceId: string, commentId: string): Observable<unknown> {
    const requestUrl = `${this.apiHost}/${type}/${referenceId}/comments/${commentId}`;
    return this.httpClient.delete<unknown>(requestUrl);
  }
}
